var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-078e7efa\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./PasswordResetConfirm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/@sdgsystems/vue-common/components/PasswordResetConfirm.vue
// module id = 387
// module chunks = 1